import { Link, useRouteLoaderData } from "@remix-run/react";
import { Sparkles } from "lucide-react";
import { getRegionUrlPrefix } from "~/lib/helpers/slugHelper";

type PropertyGptSearchPromoProps = {
  countryName: string;
};

export default function PropertyGptSearchPromo({ countryName }: PropertyGptSearchPromoProps) {
  const rootData = useRouteLoaderData("root") as { showChatbot?: boolean } | undefined;

  if (!rootData?.showChatbot) return null;

  return (
    <Link
      to={`${getRegionUrlPrefix(countryName)}/propertyGPT`}
      prefetch="intent"
      className="flex w-full items-center justify-between gap-2 rounded-b-xl border-0 border-t border-teal-100/80 bg-[#f0f9f8] px-4 py-1.5 text-xs transition-colors hover:bg-teal-50 self-stretch"
    >
      <div className="flex items-center gap-1.5 min-w-0 text-gray-800">
        <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-oh-primary">
          <Sparkles className="h-3 w-3 text-white" />
        </span>
        <span className="font-medium">Need Assistance with AI?</span>
      </div>
      <span className="shrink-0 text-[11px] font-semibold text-oh-primary whitespace-nowrap">
        Try PropertyGPT →
      </span>
    </Link>
  );
}
